import { useQueryClient } from '@tanstack/react-query';
import { marketPromotionQueryKeys } from '../api/marketPromotion.api';
import { mpP2QueryKeys } from '../api/marketPromotionP2.api';

export function useInvalidateMarketPromotion() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: marketPromotionQueryKeys.all() });
    void queryClient.invalidateQueries({ queryKey: mpP2QueryKeys.all() });
  };
}
